import BaseNormalizer from "./BaseNormalizer";

const productsNormalizer = Object.create(BaseNormalizer).init([
  "id",
  "name",
  "vat",
  "rrp",
  "productGroup",
  "purchasingPrice",
  "salesUnitType",
  "salesUnitQuantity",
  "ean",
  "edmNumber",
  "supplierArticleNumber",
  "valueProposition",
  "packaging",
  "usp",
  "brand",
  "flyerOrderable",
  "sampleOrderContent",
  "specialEventsInMarket",
  "publishOn",
  "favoritesCount",
  "alert",
  "newProductCategory",
  "releasedByStartup",
  "approvalState",
  "deletedAt",
  "images",
  "favorites.merchantAccountId",
  "isFavorite",
  "favoriteCount",
  "absoluteSellingMerchantStoreCount",
  "averageSalesCountPerStorePerWeek",
  "genericProductName",
  "productVariantName",
  "isLive",
  "isOfferingFreeSamples",
  "shippingUnitProductCount",
  "startup.name",
  "startup.edekaSupplierId",
  "startup.website",
  "startup.companyBackground",
  "startup.teamURL",
  "startup.teamImage",
  "startup.teamBackground",
  "startup.logo",
  "startup.contactPhone",
  "startup.contactName",
  "startup.contactJob",
  "startup.deliveryArea",
  "startup.productWizard",
  "startup.lineSupplier",
  "startup.edekaContract",
  "publishedVariants.name",
  "publishedVariants.id",
  "publishedVariants.images",
]);

export default productsNormalizer;
